import styled from 'styled-components';

export const NameContainer = styled.div<{ $width: string }>`
	width: ${props => props.$width || '16vw'};
`;
